module.exports = function() {
  return new Worker(__webpack_public_path__ + "f59535227232c2b28129.worker.js");
};